import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Spin } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AuthListener from "./features/auth/AuthListener";
import queryClient from "./api/queryClient";
import ErrorBoundary from "./shared/ErrorBoundary";

const Login = lazy(() => import("./features/auth/Login"));
const Register = lazy(() => import("./features/auth/Register"));
const Homepage = lazy(() => import("./features/home/Homepage"));
const ForgotPassword = lazy(() => import("./features/auth/ForgotPassword"));
const PrivateRoute = lazy(() => import("./hooks/PrivateRoute"));
const AppLayout = lazy(() => import("./layouts/AppLayout"));

// Content components rendered inside AppLayout
const Dashboardcomponent = lazy(() => import("./features/dashboard/Dashboardcomponent"));
const DesignPage = lazy(() => import("./features/workflows/DesignPage"));
const DataWorkflowPage = lazy(() => import("./features/workflows/DataWorkflowPage"));
const SavedComponent = lazy(() => import("./features/workflows/SavedComponent"));
const RunHistoryComponent = lazy(() => import("./features/jobs/Runhistorypage"));
const AllReport = lazy(() => import("./features/reports/AllReport"));
const CreditPage = lazy(() => import("./features/profile/CreditPage"));
const ProfilePage = lazy(() => import("./features/profile/ProfilePage"));
const Fastqc = lazy(() => import("./features/reports/FastqcReport"));
const Fastqc1 = lazy(() => import("./features/reports/FastqcReport1"));

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Router>
          <AuthListener />
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Spin size="large" />
              </div>
            }
          >
            <Routes>
              {/* Public routes (no sidebar) */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/resetpassword" element={<ForgotPassword />} />
              <Route path="/" element={<Homepage />} />

              {/* Protected routes with shared sidebar layout */}
              <Route
                element={
                  <PrivateRoute>
                    <AppLayout />
                  </PrivateRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboardcomponent />} />
                <Route path="/design-workflow" element={<DesignPage />} />
                <Route path="/workflows" element={<DataWorkflowPage />} />
                <Route path="/jobs" element={<SavedComponent />} />
                <Route path="/run-history" element={<RunHistoryComponent />} />
                <Route path="/reports" element={<AllReport />} />
                <Route path="/reports/:jobId" element={<AllReport />} />
                <Route path="/credits" element={<CreditPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/fastqc-report1" element={<Fastqc />} />
                <Route path="/fastqc-report2" element={<Fastqc1 />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </ErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
